import React from 'react';
import '../styles/WebSearchSourcesList.css';

export function getItemUrl(item) {
  const url = item?.url || item?.link || '';
  return typeof url === 'string' ? url.trim() : '';
}

export function WebSearchResultItem({ item }) {
  const url = getItemUrl(item);
  const title = (item?.title || '').trim();
  const displayTitle = title || url || '(untitled)';
  const showUrlLine = url && title;

  return (
    <li className="ws-result-item">
      {url ? (
        <a
          className="ws-result-title-link"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          title={url}
        >
          {displayTitle}
          <i className="fas fa-external-link-alt ws-result-external-icon" aria-hidden="true" />
        </a>
      ) : (
        <div className="ws-result-title">{displayTitle}</div>
      )}
      {showUrlLine && (
        <a
          className="ws-result-source-link"
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          title={url}
        >
          {url}
        </a>
      )}
      {item?.snippet && <div className="ws-snippet">{item.snippet}</div>}
    </li>
  );
}

export default function WebSearchSourcesList({ sources = [], title = 'Sources' }) {
  const items = Array.isArray(sources) ? sources.filter((s) => getItemUrl(s) || (s?.title || '').trim()) : [];
  if (!items.length) return null;

  return (
    <div className="chat-web-search-sources">
      <div className="chat-web-search-sources-title">{title}</div>
      <ul className="ws-result-items">
        {items.map((item, idx) => (
          <WebSearchResultItem key={`${getItemUrl(item) || item?.title || idx}`} item={item} />
        ))}
      </ul>
    </div>
  );
}
